import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PROVIDERS } from "./all-basemodule-providers"

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [],
  providers: [...PROVIDERS],
  exports: []
})
export class BaseModule {

  static forRoot(): ModuleWithProviders<BaseModule> {
    return {
      ngModule: BaseModule,
      providers: [ ...PROVIDERS ]
    };
  }

 }
